import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChargePoint } from '../../app/ApiGen';
import { Normalised } from '../../utils/request';
import { ChargePointState } from './types';

const initialState: ChargePointState = {
  loading: true,
  selectedItemId: undefined,
  error: undefined,
  current: undefined,
};

const chargePointSlice = createSlice({
  name: 'chargePointSlice',
  initialState,
  reducers: {
    getCurrentChargePointAction: (state: ChargePointState, action: PayloadAction<{ selectedItemId: string }>) => ({
      ...state,
      selectedItemId: action.payload.selectedItemId,
      loading: true,
      error: undefined,
    }),
    setCurrentChargePointAction: (
      state: ChargePointState,
      action: PayloadAction<{ chargePoint: Normalised<ChargePoint> }>,
    ) => ({
      ...state,
      selectedItemId: action.payload.chargePoint.id,
      loading: false,
      error: undefined,
      current: action.payload.chargePoint,
    }),
    setChargePointErrorAction: (
      state: ChargePointState,
      action: PayloadAction<{ error: Error; selectedItemId: string }>,
    ) => ({
      ...state,
      selectedItemId: action.payload.selectedItemId,
      loading: false,
      error: action.payload.error,
    }),
    clearCurrentChargePointAction: (state: ChargePointState) => ({
      ...state,
      selectedItemId: undefined,
      loading: false,
      error: undefined,
      current: undefined,
    }),
  },
});

export const { actions: chargePointActions, reducer: chargePointReducers } = chargePointSlice;
